import { render, staticRenderFns } from "./SlabsLayout.vue?vue&type=template&id=13ec562b&scoped=true"
import script from "./SlabsLayout.vue?vue&type=script&lang=js"
export * from "./SlabsLayout.vue?vue&type=script&lang=js"
import style0 from "./SlabsLayout.vue?vue&type=style&index=0&id=13ec562b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ec562b",
  null
  
)

export default component.exports